var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1128_10068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9044 11.0006C21.9044 16.9379 17.0913 21.7511 11.1539 21.7511C5.21651 21.7511 0.40332 16.9379 0.40332 11.0006C0.40332 5.06319 5.21651 0.25 11.1539 0.25C17.0913 0.25 21.9044 5.06319 21.9044 11.0006Z",
    fill: "white",
    stroke: "#8D8D8D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65382 15.6673C7.33299 15.6673 6.48636 15.6673 6.48636 15.6673C6.48636 15.6673 6.48676 14.8211 6.48715 14.5007H7.65382H14.6538H15.8205C15.8205 14.8215 15.8199 15.6673 15.8199 15.6673C15.8199 15.6673 14.9743 15.6677 14.6538 15.6673H7.65382ZM11.1538 13.334L8.23715 10.4173L9.05382 9.57148L10.5705 11.0882V6.33398H11.7372V11.0882L13.2538 9.57148L14.0705 10.4173L11.1538 13.334Z",
    fill: "#6F6F6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1128_10068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.15332)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAsset);
export default __webpack_public_path__ + "static/media/download-asset.40e8acae12ccc1cde36dfcfb8fc26791.svg";
export { ForwardRef as ReactComponent };